import React from 'react';
import '../assets/styles/gallery.css';

const Gallery = ({ artistName, images }) => {
  return (
    <div className="artist-section">
      <h3 className="artist-name">{artistName}</h3>
      <div className="portfolio-grid">
        {images.map((image, index) => (
          <div className="portfolio-item" key={index}>
            <img 
              src={image.src} 
              className="gallery-image"
              loading="lazy" 
              alt={image.alt}
              decoding="async"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Gallery;